export const capitalize = (s: string) => s[0].toUpperCase() + s.slice(1);
